import { Component, ElementRef, Input, OnInit, ViewChildren } from "@angular/core";
import { BaseScrollPersistingComponent } from "@common/ux/base.component/base-scroll-persisting.component";
import { DisplayObjectivesHierarchyComponent } from "../display-objectives-hierarchy.component/display-objectives-hierarchy.component";
import { IObjectiveGroup } from "../objectives.service";

@Component({
    selector: "adapt-objective-tree-view",
    templateUrl: "./objective-tree-view.component.html",
    standalone: false,
})
export class ObjectiveTreeViewComponent extends BaseScrollPersistingComponent implements OnInit {
    @Input() public objectiveGroups?: IObjectiveGroup[];
    @Input() public currentTeamId: number | null = null;
    @Input() public isCompactView = false;
    @Input() public applyFilter = false;

    public hasAnnualObjective = false;
    public hasExternalParent = false;

    @ViewChildren(DisplayObjectivesHierarchyComponent) private displayObjectivesHierarchyComponents!: DisplayObjectivesHierarchyComponent[];

    public constructor(
        elementRef: ElementRef,
    ) {
        super(elementRef);
    }

    public ngOnInit() {
        this.rememberScrollPosition(`ObjectiveTreeView-${this.currentTeamId ?? "org"}-${this.isCompactView}`);
    }

    public collapse() {
        this.displayObjectivesHierarchyComponents.forEach((component) => component.collapse());
    }

    public expand() {
        this.displayObjectivesHierarchyComponents.forEach((component) => component.expand());
    }
}
